// extracted by mini-css-extract-plugin
export var arrows = "_1u-6";
export var decrementer = "_1u-a";
export var disabled = "_1u-4";
export var error = "_1u-1";
export var hiddenText = "_1u-b";
export var incrementer = "_1u-9";
export var input = "_1u-8";
export var inputWrapper = "_1u-0";
export var leadingIcon = "_1u-c";
export var readonly = "_1u-3";
export var regular = "_1u-7";
export var small = "_1u-5";
export var warning = "_1u-2";